import { Icon, IconButton } from "rsuite";
import { useHistory, useLocation } from "react-router-dom";

export interface ActionsCellProps {
  idObject: number | string;
  path: string | undefined;
}
export const ActionsCell = (props: ActionsCellProps) => {
  const location = useLocation();
  const history = useHistory();

  return (
    <IconButton
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        const basePath = props.path
          ? `/${props.path.replace(/^\/|\/$/g, "")}`
          : location.pathname.replace(/\/$/, "");
        history.push(`${basePath}/${props.idObject}`);
      }}
      size="sm"
      icon={<Icon icon="more" size="lg" />}
    />
  );
};
